import { render, staticRenderFns } from "./ApprTemp5.vue?vue&type=template&id=a8543bb2&scoped=true&"
import script from "./ApprTemp5.vue?vue&type=script&lang=js&"
export * from "./ApprTemp5.vue?vue&type=script&lang=js&"
import style0 from "./ApprTemp5.vue?vue&type=style&index=0&id=a8543bb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8543bb2",
  null
  
)

export default component.exports